import { Stack, Typography } from '@mui/material'
import { ScheduleTypeEnum } from '@ulysses-inc/harami_api_client'
import type React from 'react'
import FrequencySelectOptionInDate from 'src/features/schedules/editSchedule/FrequencySelectOptionInDate'
import FrequencySelectOptionInDuration from 'src/features/schedules/editSchedule/FrequencySelectOptionInDuration'
import type { TBaseFormRowProps } from './EditSchedule'

const ScheduleFrequencyRow: React.FC<TBaseFormRowProps> = ({
  setFieldValue,
  values: {
    type,
    frequency,
    frequencyWeekly,
    frequencyMonthly,
    frequencyCustom,
  },
  errors,
  touched,
  submitCount,
}) => (
  <Stack spacing={2}>
    <Typography variant="subtitle1" fontWeight="bold">
      頻度
    </Typography>
    {type === ScheduleTypeEnum.Date && (
      <FrequencySelectOptionInDate
        errors={errors}
        touched={touched}
        submitCount={submitCount}
        frequency={frequency ?? null}
        frequencyWeekly={frequencyWeekly}
        frequencyMonthly={frequencyMonthly}
        setFieldValue={setFieldValue}
      />
    )}
    {type === ScheduleTypeEnum.Duration && (
      <FrequencySelectOptionInDuration
        errors={errors}
        touched={touched}
        submitCount={submitCount}
        frequency={frequency ?? null}
        frequencyWeekly={frequencyWeekly}
        frequencyMonthly={frequencyMonthly}
        frequencyCustom={frequencyCustom}
        setFieldValue={setFieldValue}
      />
    )}
  </Stack>
)

export default ScheduleFrequencyRow
